import React from 'react';
import './Footer.css'; // Assuming you have a CSS file for styling the footer

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer-content">
        <p>© {currentYear} Pisces. All rights reserved.</p>
        <p>
          <a href="/privacy-policy">Privacy Policy</a>
        </p>
        {/* Add more links or information as needed */}
      </div>
    </footer>
  );
};

export default Footer;
